import {
  initialState,
  Actions,
  State,
  GET_ALL_PROVINCES,
  GET_ALL_PROVINCES_SUCCESS,
  GET_ALL_PROVINCES_ERROR,
} from "../types/statics";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_PROVINCES:
      return {
        ...state,
        allProvinces: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case GET_ALL_PROVINCES_SUCCESS:
      return {
        ...state,
        allProvinces: {
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case GET_ALL_PROVINCES_ERROR:
      return {
        ...state,
        allProvinces: {
          data: null,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    default:
      return state;
  }
};

export default reducers;
